import { Tag } from 'antd';
import { 
  CheckCircleOutlined, 
  CloseCircleOutlined, 
  ClockCircleOutlined, 
  WarningOutlined,
  FieldTimeOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';

const statusConfig = {
  CONFIRMED: {
    label: 'Confirmed',
    color: 'success',
    icon: <CheckCircleOutlined />,
  },
  FAILED: {
    label: 'Failed',
    color: 'error',
    icon: <CloseCircleOutlined />,
  },
  IN_PROGRESS: {
    label: 'In Progress',
    color: 'processing',
    icon: <ClockCircleOutlined />,
  },
  ABANDONED_CHECKOUT: {
    label: 'Abandoned',
    color: 'warning',
    icon: <WarningOutlined />,
  },
  EXPIRED: {
    label: 'Expired',
    color: 'purple',
    icon: <FieldTimeOutlined />,
  },
  completed: {
    label: 'Completed',
    color: 'success',
    icon: <CheckCircleOutlined />,
  },
  failed: {
    label: 'Failed',
    color: 'error',
    icon: <CloseCircleOutlined />,
  },
  pending: {
    label: 'Pending',
    color: 'processing',
    icon: <ClockCircleOutlined />,
  },
  skipped: {
    label: 'Skipped',
    color: 'default',
    icon: <MinusCircleOutlined />,
  },
};

export function StatusBadge({ status }) {
  const config = statusConfig[status];

  return (
    <Tag color={config?.color || '#0000'} icon={config?.icon}>
      {config?.label}
    </Tag>
  );
}
